export const LOGIN = 'v1/login';
export const REGISTER = 'v1/registration';
export const LOGIN_GOOGLE_START = 'v1/login/google'
export const LOGIN_GOOGLE_CALLBACK = 'v1/login/oauth2/code/google'
export const LOGIN_YANDEX_START = 'v1/login/yandex'
export const LOGIN_YANDEX_CALLBACK = 'v1/login/oauth2/code/yandex'
export const LOGIN_OAUTH_PROVIDERS = 'v1/login/oauth/providers'
export const FORGOT_PASSWORD = 'v1/login/forgot_pw'

export const CATEGORIES = 'v1/categories'
export const ITEMS_ID = `v1/items/`
export const ITEMS_ALL = 'v1/items'
export const CART_ITEM_ID = 'v1/user/cart/'
export const CART = 'v1/user/cart'
export const USER_SHIPMENT = 'v1/user/shipment'
export const USER_PASSWORD = 'v1/user/password'
export const USER = 'v1/user'

export const ORDERS_ID = 'v1/orders/'
export const ORDERS_ADMIN_ID = 'v1/admin/orders/'
export const ORDERS = 'v1/orders'
export const ORDERS_ADMIN = 'v1/admin/orders'
export const ORDERS_STATUSES = 'v1/admin/orders/statuses'
export const ORDERS_ADMIN_STATS = 'v1/admin/orders/stats'

/** Станция отгрузки (Яндекс B2B pickup-points/list) для виджета НДД */
export const YANDEX_WAREHOUSE_PICKUP = 'v1/yandex/pickup-points/warehouse'